import React from 'react';
import PropTypes from 'prop-types';
import { Modal, P } from '@decisiv/ui-components';
import Trash from '@decisiv/iconix/lib/components/Trash';
import { t, Trans } from '@lingui/macro';

const RemoveLocationAttributesModal = ({
  visible,
  removedNames,
  onConfirm,
  onClose,
}) => (
  <Modal
    actions={[
      { text: t`Remove and Save`, onClick: onConfirm, intent: 'danger' },
      { text: t`Cancel`, onClick: onClose },
    ]}
    icon={Trash}
    color="danger"
    onClose={onClose}
    title={t`Remove Location Setting Attributes`}
    visible={visible}
  >
    <P color="alaskanHusky" weight="medium" marginTop={1}>
      <Trans>
        Removing <strong>{removedNames.join(', ')}</strong> will permanently
        delete its value from all configured locations for this integration.
        This cannot be undone. Do you want to continue?
      </Trans>
    </P>
  </Modal>
);

RemoveLocationAttributesModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  removedNames: PropTypes.arrayOf(PropTypes.string).isRequired,
  onConfirm: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default RemoveLocationAttributesModal;
